import React from "react";
import { CheckCircle2, AlertCircle, Info, HelpCircle } from "lucide-react";

const tones = {
  verified: { icon: CheckCircle2, classes: "border-emerald-200 bg-emerald-50 text-emerald-800" },
  partial: { icon: AlertCircle, classes: "border-amber-200 bg-amber-50 text-amber-800" },
  disclosed: { icon: Info, classes: "border-blue-200 bg-blue-50 text-blue-800" },
  unverified: { icon: HelpCircle, classes: "border-slate-300 bg-slate-100 text-slate-700" },
};

export const EvidenceStatus = ({ label, tone = "unverified", detail, testId = "evidence-status-badge" }) => {
  const config = tones[tone] || tones.unverified;
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center gap-1.5 border px-2.5 py-1 text-xs font-semibold ${config.classes}`}
      title={detail}
      data-testid={testId}
    >
      <Icon className="h-3.5 w-3.5" aria-hidden="true" />
      {label}
    </span>
  );
};
